<div class="table-container">
  <table mat-table [dataSource]="forms" matSort>

    <ng-container matColumnDef="level">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"intelligence-reporting.forms.level" |translate}}</th>
      <td mat-cell *matCellDef="let form">{{form.level}}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.countries.name" |translate}}</th>
      <td mat-cell *matCellDef="let form">{{form.name}}</td>
    </ng-container>

    <ng-container matColumnDef="year">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"kf-reporting.year" |translate}}</th>
      <td mat-cell *matCellDef="let form">{{form.year}}</td>
    </ng-container>

    <ng-container matColumnDef="form">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"intelligence-data-entry.form" |translate}}</th>
      <td mat-cell *matCellDef="let form">{{form.form}}</td>
    </ng-container>

    <ng-container matColumnDef="launched">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"kf-reporting.launched" |translate}}</th>
      <td mat-cell *matCellDef="let form">{{datePipe.transform(form.launched, 'yyyy-MM-dd HH:mm:ss')}}</td>
    </ng-container>

    <ng-container matColumnDef="questions">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Total no. of questions</th>
      <td mat-cell *matCellDef="let form" class="text-align-center">{{form.questions}}</td>
    </ng-container>

    <ng-container matColumnDef="answered">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'intelligence-data-entry.unanswered' |translate}}</th>
      <td mat-cell *matCellDef="let form" class="text-align-center">{{form.questions - form.answered}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'admin.countries.status' |translate}}</th>
      <td mat-cell *matCellDef="let form">{{form.status !== 'NOT_STARTED' ? form.status : 'NOT STARTED'}}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let form">
        <mat-icon (click)="openForm(form)" color="primary"
                  matTooltip="Edit" matTooltipPosition="above">edit
        </mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>

